<template>
  <div>
    <NewsPage
      :id="id"
      :type="type"
      v-if="type === 'news' || type === 'api' || type === 'document'"
      ref="NewsPage"
    />
    <WeMedia
      :id="id"
      :type="type"
      v-if="type === 'twitter' || type === 'weibo' || type === 'facebook'"
      ref="WeMedia"
    />
    <Toutiao :id="id" :type="type" v-if="type === 'toutiao'" ref="Toutiao" />
  </div>
</template>

<script>
import NewsPage from './News/index'
import WeMedia from './WeMedia/index'
import Toutiao from './Toutiao/index'

export default {
  props: {
    // type: {
    //   default: ''
    // },
    // id: {
    //   default: ''
    // }
  },
  components: {
    NewsPage,
    WeMedia,
    Toutiao
  },
  data() {
    return {
      type: '',
      id: ''
    }
  },
  mounted() {
    // const { type } = this.$route.query
    // if (type) {
    //   this.type = type
    // }
  },
  methods: {
    sendData(id, type) {
      this.id = id
      this.type = type
    },
    reload() {
      let type = this.type
      if (type === 'news' || type === 'api' || type === 'document') {
        this.$refs['NewsPage'].reload()
      }
      if (type === 'twitter' || type === 'weibo' || type === 'facebook') {
        this.$refs['WeMedia'].reload()
      }
      if (type === 'toutiao') {
        this.$refs['Toutiao'].reload()
      }
    }
  }
}
</script>
